import { inject, Service } from '@angular/core';
import { Router } from '@angular/router';
import { cloneDeep } from 'lodash-es';

import { Activity, Breadcrumb, Event, ResourceType, Room } from '@models';
import { ModalService } from './modal.service';

type BreadcrumbLike = Pick<Breadcrumb, 'rid' | 'displayName' | 'type'>;

@Service()
export class TaskService {
  modalService = inject(ModalService);
  router = inject(Router);

  editTask = async (resource: Activity, parentType: ResourceType) => {
    const { EditTaskModalComponent } =
      await import('../../modules/task/components/edit-task-modal.component');

    return this.modalService.open(
      EditTaskModalComponent,
      {
        resource: cloneDeep(resource),
        parentType,
      },
      {
        modalDialogClass: 'lg-modal',
      }
    );
  };

  openTask = async (
    resource: Activity | number,
    parentResource?: (Room | Event | Breadcrumb | BreadcrumbLike)[]
  ) => {
    const { TaskModalComponent } =
      await import('../../modules/task/components/task-modal');

    return this.modalService
      .open(
        TaskModalComponent,
        {
          resource,
          parentResource,
        },
        {
          modalDialogClass: 'lg-modal',
        }
      )
      .catch(() => {
        if (!this.router.currentNavigation()) {
          this.router.navigate([], {
            queryParams: {
              task: null,
            },
            queryParamsHandling: 'merge',
          });
        }
      });
  };
}
